const nullOrUndefined = (value) => {
    return value === null || value === undefined; 
}

export default nullOrUndefined; 